module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("Job-Wise Profit & Loss (Tally)")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(!_vm.isLoading) ? _c('small', [_vm._v(_vm._s(_vm.totalUniqueJobs) + " Unique Jobs")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.dateRange.startDate || _vm.Filter.dateRange.endDate ? 'outline-danger' : 'outline-primary'
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.Filter.dateRange.startDate || _vm.Filter.dateRange.endDate ? "Filter ON" : "Filter OFF") + "\n          ")]), _vm._v(" "), (_vm.getAssignmentData.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel',
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.exportJobWiseReport()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('div', [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalUniqueJobs,
      "per-page": _vm.pagination.perPage
    },
    on: {
      "input": _vm.onPageChange
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date Range")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": false,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.fetchData
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": "Common Filter"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Invoice Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": "Invoice Filter"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.invFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "invFilter", $$v)
      },
      expression: "Filter.invFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Job No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": "Job No Filter"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.jobFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "jobFilter", $$v)
      },
      expression: "Filter.jobFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "table-background position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "fields": _vm.getAssignmentFields,
      "items": _vm.getAssignmentData
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s((_vm.pagination.currentPage - 1) * _vm.pagination.perPage + row.index + 1))])]
      }
    }, {
      key: "JOB_Details",
      fn: function(row) {
        return [_c('span', [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(row.item.JOBNO))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Date:")]), _vm._v(" " + _vm._s(row.item.JOBDate) + " (" + _vm._s(row.item.MonthName) + ")")]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Type:")]), _vm._v(" " + _vm._s(row.item.JOBTYPE))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Booking:")]), _vm._v(" " + _vm._s(row.item.BookingNo))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Client:")]), _vm._v(" " + _vm._s(row.item.ClientName))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Branch:")]), _vm._v(" " + _vm._s(row.item.Branch))]), _c('br'), _vm._v(" "), (row.item.ContractNo && row.item.ContractNo !== 'NA') ? _c('span', [_c('strong', [_vm._v("Contract:")]), _vm._v(" " + _vm._s(row.item.ContractNo))]) : _vm._e(), _c('br'), _vm._v(" "), (row.item.JobId && _vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('TimelineModal', {
          attrs: {
            "PMC_title": 'Timeline Summary Job No - ' + row.item.JOBNO,
            "PMC_JOBID": (row.item.JobId),
            "PMC_JOBNO": row.item.JOBNO,
            "PMC_JOBDATE": row.item.JOBDate,
            "PMC_JOBTYPE": row.item.JOBTYPE,
            "PMC_AgentType": '',
            "PMC_Client": row.item.ClientName,
            "PMC_Sline": row.item.ShippingLine
          }
        }) : _vm._e(), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port' && row.item.JobId) ? _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "assign_date": row.item.JOBDate,
            "assign_job_type": row.item.JOBTYPE,
            "assign_raised_from": '',
            "assign_raised_by": '',
            "fk_all_module_id": (row.item.JobId),
            "jb_series": row.item.JOBNO,
            "fk_client_id": '',
            "fk_pod_id": ''
          }
        }) : _vm._e(), _vm._v(" "), (row.item.JobId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row.item.JOBNO,
            "PMC_JOBID": (row.item.JobId),
            "PMC_JOBNO": row.item.JOBNO,
            "PMC_JOBDATE": row.item.JOBDate,
            "PMC_JOBTYPE": row.item.JOBTYPE,
            "PMC_AgentType": '',
            "PMC_Client": row.item.ClientName,
            "PMC_Sline": row.item.ShippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row.item.JobId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row.item.JOBNO,
            "PMC_JOBID": (row.item.JobId),
            "PMC_JOBNO": row.item.JOBNO,
            "PMC_JOBDATE": row.item.JOBDate,
            "PMC_JOBTYPE": row.item.JOBTYPE,
            "PMC_AgentType": '',
            "PMC_Client": row.item.ClientName,
            "PMC_Sline": row.item.ShippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row.item.JobId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": (row.item.JobId),
            "JobNo": row.item.JOBNO
          }
        }) : _vm._e(), _vm._v(" "), (row.item.JobId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' +
              row.item.JOBNO,
            "PMC_JOBID": (row.item.JobId),
            "PMC_JOBNO": row.item.JOBNO,
            "PMC_JOBDATE": row.item.JOBDate,
            "PMC_JOBTYPE": row.item.JOBTYPE,
            "PMC_Client": row.item.ClientName,
            "PMC_Sline": row.item.ShippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row.item.JobId) ? _c('AssignmentSplitMergeSummary', {
          attrs: {
            "PMC_title": 'Assignment Split/Merge/Move Summary Job No - ' + row.item.JOBNO,
            "PMC_JOBID": (row.item.JobId),
            "PMC_JOBNO": row.item.JOBNO,
            "PMC_JOBDATE": row.item.JOBDate,
            "PMC_JOBTYPE": row.item.JOBTYPE,
            "PMC_AgentType": '',
            "PMC_Client": row.item.ClientName,
            "PMC_Sline": row.item.ShippingLine
          }
        }) : _vm._e()]
      }
    }, {
      key: "Status_Details",
      fn: function(row) {
        return [_c('span', [_c('strong', [_vm._v("FF/CC/TPT:")]), _vm._v(" " + _vm._s(row.item.ffExInv) + " / " + _vm._s(row.item.ccExInv) + " / " + _vm._s(row.item.tptExInv))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Billing:")]), _vm._v(" " + _vm._s(row.item.billingStatus))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Final Bill:")]), _vm._v(" " + _vm._s(row.item.finalBill))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Tally Inv:")]), _vm._v(" " + _vm._s(row.item.tallyExistInvoice || 'None'))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Overseas:")]), _vm._v(" " + _vm._s(row.item.overseasBillingStatus))])]
      }
    }, {
      key: "Freight_Details",
      fn: function(row) {
        return [_c('span', [_c('strong', [_vm._v("Overseas Income:")]), _vm._v(" " + _vm._s(row.item.OceanFreightOverseasIncome))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Overseas Expense:")]), _vm._v(" " + _vm._s(row.item.OceanFreightOverseasExpense))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Freight Charges:")]), _vm._v(" " + _vm._s(row.item.OceanFreightCharges))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Expense Charges:")]), _vm._v(" " + _vm._s(row.item.OceanFreightExpenseCharges))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Other Income:")]), _vm._v(" " + _vm._s(row.item.OtherIncome))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Total Exp/Rev:")]), _vm._v(" " + _vm._s(row.item.exp_inv_amt) + " / " + _vm._s(row.item.rev_inv_amt))])]
      }
    }, {
      key: "Profit_Loss",
      fn: function(row) {
        return [_c('div', {
          staticClass: "p-1",
          style: ({
            backgroundColor: parseFloat(row.item.pl_profit) >= 0 ? '#e6fffa' : '#fff5f5',
            borderRadius: '4px'
          })
        }, [_c('span', [_c('strong', [_vm._v("Expense:")]), _vm._v(" " + _vm._s(row.item.pl_expense))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Invoice:")]), _vm._v(" " + _vm._s(row.item.pl_invoice))]), _c('br'), _vm._v(" "), _c('span', {
          class: parseFloat(row.item.pl_profit) >= 0 ? 'text-success' : 'text-danger'
        }, [_c('strong', [_vm._v("Profit/Loss:")]), _vm._v(" " + _vm._s(row.item.pl_profit) + "\n                  ")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalUniqueJobs,
      "per-page": _vm.pagination.perPage
    },
    on: {
      "input": _vm.onPageChange
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17c80ea8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ulip/OceanFreightJobWiseProfitLoss.vue
// module id = 2417
// module chunks = 0